import { Modal, ModalHeader } from 'baseui/modal'
import { Search } from 'baseui/icon'
import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePceSearchV2 from './usePceSearchV2'
import PceSearchForm from './PceSearchForm'
import PceSearchResults from './PceSearchResults'

const PceSearchModal = () => {
  const { t } = useTranslation()
  const { isOpen, currentViewPage, resetPceSearchData, updatePceConfigData } = usePceSearchV2()

  const handleClose = () => {
    updatePceConfigData({ isOpen: false })
    resetPceSearchData()
  }

  return (
    <Modal
      onClose={handleClose}
      isOpen={isOpen}
      size={SIZE.auto}
      overrides={{
        Dialog: {
          style: {
            width: 'auto',
            maxWidth: '90vw',
          },
        },
      }}
    >
      <ModalHeader
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          backgroundColor: '#f7f7f7',
          borderBottom: '0.0625rem solid #e0e0e0',
          padding: '1rem 1.5rem',
        }}
      >
        <Search size={21} />
        {t('subscriptionTools:pce_search.module_title')}
      </ModalHeader>

      {currentViewPage === 'search' && <PceSearchForm />}
      {currentViewPage === 'results' && <PceSearchResults />}
    </Modal>
  )
}

export default PceSearchModal
